import { useEffect, useState } from "react"
import { FcApproval } from "react-icons/fc";
import { FcCancel } from "react-icons/fc";
import { FcSynchronize } from "react-icons/fc";
import Swal from "sweetalert2";



import './solicitudCard.css'

const SolicitudCard = ({dataNequi, dataUser, socket})=>{
    
    const [isOpen, setIsOpen] = useState(false);
    const [user, setUser] = useState({})
    const toggleDetails = () => {
        setIsOpen(!isOpen);
    }
    useEffect(()=>{
        socket.on('ResponseCancelNequi',(response)=>{
            Swal.fire(response.message)
        })
        socket.on('ResponseModificarNequi',(response)=>{
            Swal.fire(response.message)
        })
        socket.on('ResponseAprobarCuenta',(response)=>{
            Swal.fire(response.message, `nuevo saldo: ${response.newSaldo}`)
          })
        
    })
    useEffect(()=>{
        if(dataUser){
            setUser(dataUser)
        }
    },[dataUser])

    const CancelEmit = ()=>{
        Swal.fire({
            title:'Causa de cancelacion',
            input:'text',
            inputPlaceholder:'Describe las razones o causas que dan motivo a la cancelacion',
            showCancelButton:true,
            confirmButtonText: 'Enviar',
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => {
                if (!value) {
                    return 'Debes escribir algo!';
                }
            }
        }).then((result)=>{
            if(result.isConfirmed){
                // console.log(result.value)
                socket.emit('CancelRecargaCuenta',{
                    motivo: result.value,
                    id: dataNequi.id,
                    uid: user.uid
                })
            }
        })
    }
    const ModificarEmit = ()=>{
        Swal.fire({
            title:'Monto valido',
            input:'number',
            inputPlaceholder:'Escribe el monto correcto',
            showCancelButton:true,
            confirmButtonText: 'Modificar',
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => {
                if (!value) {
                    return 'Debes escribir algo!';
                }
            }
        }).then((result)=>{
            socket.emit('modificarRecargaCuenta',{
                monto:result.value,
                id:dataNequi.id,
                uid:user.uid
            })
        })
    }
    const AprobadoEmit = async()=>{
        if(dataNequi.state==='Aprobada'){
            Swal.fire('la solicitud ya fue aprobada')
            return
        }
        const result = await Swal.fire({
            title: "¿Confirmacion de aprobacion?",
            text: "Una vez enviada la confirmacion, se cargara el monto solicitado a la cuenta del usuario",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, Aprobar",
            cancelButtonText: "Cancelar",
        });
        if (result.isConfirmed) {
            socket.emit('aprobarRecargaCuenta',dataNequi.id)
        }
    }
    return(
        <div className="soli-Card">
            <div className="soli-header" onClick={toggleDetails}>
                <p>{dataNequi.id}</p>
                <p>{dataNequi.state}</p>
                <button className="toggle-btn">{isOpen ? '−' : '+'}</button>
            </div>
            {isOpen && (
                <div className="soli-details">
                    <div className="soliDetails-header">
                        <img src={dataNequi.comprobante} alt="" className="soliDetails-photo" />
                    </div>
                    <table className="soli-option">
                        <tbody>
                            <tr>
                                <td><FcApproval size={50} onClick={AprobadoEmit}/></td>
                                <td><FcSynchronize size={50} onClick={ModificarEmit}/></td>
                                <td><FcCancel size={50} onClick={CancelEmit}/></td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="soli-tableData">
                        <tbody>
                            <tr>
                                <td><strong>Correo:</strong></td>
                                <td>{user.correo}</td>
                            </tr>
                            <tr>
                                <td><strong>Nombre:</strong></td>
                                <td>{user.nombre}</td>
                            </tr>
                            <tr>
                                <td><strong>Saldo Actual:</strong></td>
                                <td>{dataNequi.saldoActual}</td>
                            </tr>
                            <tr>
                                <td><strong>Monto Solicitado:</strong></td>
                                <td>{dataNequi.montoCarga}</td>
                            </tr>
                            <tr>
                                <td><strong>Fecha Solicitud:</strong></td>
                                <td>{dataNequi.fecha}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    )
}
export default SolicitudCard